import {
  CLEAR_FILTERS,
  CHANGE_ASSIGNEE_FILTER,
  CHANGE_CREATOR_FILTER,
  CHANGE_END_DATE_FILTER,
  CHANGE_SEARCH_TEXT,
  CHANGE_START_DATE_FILTER,
  CHANGE_STATUS_FILTER,
  CHANGE_TASK_TYPE_FILTER,
  CHANGE_TAGS_FILTER,
  SET_CALL_LIST_ID,
  TOGGLE_INCLUDE_UNTAGGED
} from '../actions/query';

export default (state, action) => {
  state = state || {};

  switch (action.type) {
  case CHANGE_ASSIGNEE_FILTER:
    return { ...state, assigneeId: action.id };
  case CHANGE_CREATOR_FILTER:
    return { ...state, creatorId: action.id };
  case CHANGE_END_DATE_FILTER:
    return { ...state, endDate: action.date };
  case CHANGE_SEARCH_TEXT:
    return { ...state, searchText: action.text };
  case CHANGE_START_DATE_FILTER:
    return { ...state, startDate: action.date };
  case CHANGE_STATUS_FILTER:
    return { ...state, status: action.status };
  case CHANGE_TASK_TYPE_FILTER:
    return { ...state, taskType: action.taskType };
  case CHANGE_TAGS_FILTER:
    return { ...state, tagIds: action.tagIds };
  case TOGGLE_INCLUDE_UNTAGGED:
    return { ...state, includeUntagged: !state.includeUntagged };
  case CLEAR_FILTERS: {
    return {
      ...state,
      assigneeId: null,
      creatorId: null,
      includeUntagged: false,
      searchText: '',
      tagIds: [],
      taskType: null,
      status: null
    };
  }
  case SET_CALL_LIST_ID:
    return { ...state, callListId: action.callListId };
  default:
    return state;
  }
};
